import { render, staticRenderFns } from "./DsfPptsSetting.vue?vue&type=template&id=73740baa&"
import script from "./DsfPptsSetting.vue?vue&type=script&lang=js&"
export * from "./DsfPptsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73740baa')) {
      api.createRecord('73740baa', component.options)
    } else {
      api.reload('73740baa', component.options)
    }
    module.hot.accept("./DsfPptsSetting.vue?vue&type=template&id=73740baa&", function () {
      api.rerender('73740baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/control/DsfPptsSetting.vue"
export default component.exports